module.exports = __webpack_public_path__ + "c2c66bd9359e4106429b559f63ab7f73.jpg";